<template>
    <div id="component" class="text-left">
        <div class="text-left mb-2">
            <b-btn variant="primary" class="text-nowrap mr-1" @click="bePreRun" v-if="model.ats.Query != ''">Test Query</b-btn>
            <b-btn variant="primary" class="text-nowrap mr-1" @click="beSave" v-if="flagModelIsChanged || model.isNew()">Save</b-btn>
            <b-btn variant="danger" class="text-nowrap mr-1" @click="beDelete">Delete</b-btn>
            <b-btn variant="secondary" class="text-nowrap mr-1" @click="onDiscard" v-if="flagModelIsChanged  && !model.isNew()">Revert</b-btn>
        </div>
        <div>
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Report" active>
                        <b-card-text>
                            <div>
                                <b-row class="my-1">
                                    <b-col sm="1">
                                        <label for="input-large" class="text-bigger">Name:</label>
                                    </b-col>
                                    <b-col sm="11">
                                        <b-form-input id="input-large" size="lg" v-model="model.ats.Name"></b-form-input>
                                    </b-col>
                                </b-row>
                                <div>
                                    <b-row class="my-1">
                                        <b-col sm="1">
                                            <label for="report-source" class="text-bigger">Source:</label>
                                        </b-col>
                                        <b-col sm="11">
                                            <select v-model="model.ats.Source" class="custom-select" id="report-source">
                                                <option :value="null">---</option>
                                                <option v-for="(source, i) in vocSourceToName" :value="i">{{ source }}</option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="mb-1">&nbsp;</div>
                                <div>
                                    <b-form-group label="Query:" class="text-left" label-class="text-bigger">
                                        <b-form-textarea
                                                v-model="model.ats.Query"
                                                rows="15"
                                                class="vh-h-50"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="mb-3"></div>
                            </div>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Parameters">
                        <b-card-text>
                            <!-- ################################################## -->
                            <!-- region model.ats.Parameters-->
                            <div class="scrollable-table-wrapper">
                                <div class="scr-tbl-cont vh-h-70">
                                    <table class="table">
                                        <thead class="header">
                                        <tr>
                                            <th class="pct-w-5">&nbsp;</th>
                                            <th class="pct-w-5 text-nowrap">Order</th>
                                            <th class="pct-w-10">Parameter ID</th>
                                            <th class="pct-w-10">Report Column Name</th>
                                            <th class="pct-w-10">Type</th>
                                            <th class="pct-w-10">Subtype</th>
                                            <th class="pct-w-40">Value</th>
                                            <th class="pct-w-10">
                                                <button class="btn btn-sm btn-success" @click="parametersInsertNew(0)" title="Add">+</button>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                                v-for="(item, index) in model.ats.Parameters"
                                                :class="{ 'bg-warning': !item._localValidationStatus }"
                                        >
                                            <td class="pct-w-5">
                                                <b-btn variant="primary" @click="parametersReorder(index, -1)" title="Move Up" :disabled="index == 0">&uArr;</b-btn>
                                                <div class="mb-1"></div>
                                                <b-btn variant="primary" @click="parametersReorder(index, 1)" title="Move Down" :disabled="index+1 == model.ats.Parameters.length">&dArr;</b-btn>
                                            </td>
                                            <td class="pct-w-5 text-center">{{ item.ats.Order }}</td>
                                            <td class="pct-w-10">
                                                <div class="form-group">
                                                    <input v-model="item.ats.DbName" type="text" class="form-control">
                                                </div>
                                            </td>
                                            <td class="pct-w-10">
                                                <div class="form-group">
                                                    <input v-model="item.ats.Name" type="text" class="form-control">
                                                </div>
                                            </td>
                                            <td class="pct-w-10">
                                                <div class="form-group">
                                                    <select v-model="item.ats.Type" class="custom-select" @change="item.ats.SubType=null">
                                                        <option :value="null">---</option>
                                                        <option v-for="(v, type) in vocTypeSubType" :value="type">{{ type }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td class="pct-w-10">
                                                <div class="form-group">
                                                    <select v-model="item.ats.SubType" class="custom-select">
                                                        <option :value="null">---</option>
                                                        <option v-for="subtype in vocTypeSubType[item.ats.Type]" :value="subtype">{{ subtype }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td class="pct-w-40">
                                                <parameter :definition="JSON.parse(JSON.stringify(item.ats))" @changed="onParameterValueChanged" :mode-restricted="true"/>
                                            </td>
                                            <td class="pct-w-10">
                                                <div class="container-fluid">
                                                    <div class="row flex-nowrap align-items-center no-gutters">
                                                        <div class="col">
                                                            <button class="btn btn-sm btn-success" @click="parametersInsertNew(index)" title="Add above">+&uArr;</button>
                                                            <div class="mb-1"></div>
                                                            <button class="btn btn-sm  btn-success" @click="parametersInsertNew(index+1)" title="Add below">+&dArr;</button>
                                                        </div>
                                                        <div class="col ml-1">
                                                            <button class="btn btn-sm btn-danger" @click="parametersDelete(index)" title="Delete">X</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- endregion model.ats.Parameters-->
                            <!-- ################################################## -->
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Column Formats">
                        <b-card-text>
                            <!-- ################################################## -->
                            <!-- region model.ats.Columns-->
                            <div class="scrollable-table-wrapper">
                                <div class="scr-tbl-cont vh-h-70">
                                    <table class="table">
                                        <thead class="header">
                                        <tr>
                                            <th class="pct-w-5">&nbsp;</th>
                                            <th class="pct-w-5 text-nowrap">Order</th>
                                            <th class="pct-w-20">Query Alias</th>
                                            <th class="pct-w-20">Report Label</th>
                                            <th class="pct-w-20">Total</th>
                                            <th class="pct-w-20">DataType</th>
                                            <th class="pct-w-10">
                                                <button class="btn-success" @click="columnsInsertNew(0)" title="Add">+</button>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                                v-for="(item, index) in model.ats.Columns"
                                                :class="{ 'bg-warning': !item._localValidationStatus }"
                                        >
                                            <td class="pct-w-5">
                                                <b-btn variant="primary" @click="columnsReorder(index, -1)" title="Move Up" :disabled="index == 0">&uArr;</b-btn>
                                                <div class="mb-1"></div>
                                                <b-btn variant="primary" @click="columnsReorder(index, 1)" title="Move Down" :disabled="index+1 == model.ats.Columns.length">&dArr;</b-btn>
                                            </td>
                                            <td class="pct-w-5 text-center">
                                                {{ item.ats.Order }}
                                            </td>
                                            <td class="pct-w-20">
                                                <div class="form-group">
                                                    <input v-model="item.ats.DbName" type="text" class="form-control">
                                                </div>
                                            </td>
                                            <td class="pct-w-20">
                                                <div class="form-group">
                                                    <input v-model="item.ats.Name" type="text" class="form-control">
                                                </div>
                                            </td>
                                            <td class="pct-w-20">
                                                <div class="form-group text-center">
                                                    <input type="checkbox" v-model="item.ats.Total">
                                                </div>
                                            </td>
                                            <td class="pct-w-20">
                                                <div class="form-group">
                                                    <select v-model="item.ats.DataType" class="custom-select">
                                                        <option :value="null">---</option>
                                                        <option v-for="(v, i) in vocDataTypeFormat" :value="i">{{ i }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td class="pct-w-10 pl-0">
                                                <div class="">
                                                    <div class="row flex-nowrap align-items-center no-gutters">
                                                        <div class="col">
                                                            <button class="btn-success" @click="columnsInsertNew(index)" title="Add above">+&uArr;</button>
                                                            <div class="mb-1"></div>
                                                            <button class="btn-success" @click="columnsInsertNew(index+1)" title="Add below">+&dArr;</button>
                                                        </div>
                                                        <div class="col ml-1">
                                                            <button class="btn-danger" @click="columnsDelete(index)" title="Delete">X</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- endregion model.ats.Columns-->
                            <!-- ################################################## -->
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Report Results">
                        <b-card-text>
                            <report-table :data="reportData" :columnFormatters="reportColumnFormatters"></report-table>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import mReport from "@/models/mReport";
import {arrayElInsertAt, arrayElRemoveByIndex, arrayElSetEarlier, arrayElSetLater, arrayElsSwap} from "@/utilities/ArrayUtils";
import mReportParameter from "@/models/mReportParameter";
import ObjAlertState from "@/components/common/alert/ObjAlertState";
import mReportColumn from "@/models/mReportColumn";
import Parameter from '@/components/common/parameterValuePicker/Parameter';
import ReportTable from '@/components/reports/ReportTable';

export default {
  components: {
    Parameter,
    ReportTable
  },
  props: {
    'model': mReport,
    'index': Number
  },
  data() {
    return {
      vocSourceToName: mReport.vocSourceToName(),
      vocTypeSubType: mReportParameter.vocTypeSubType(),
      vocDataTypeFormat: mReportColumn.vocDataTypeFormat(),
      flagModelIsChanged: false,
      oParValSequence: {}
    }
  },
  computed: {
    reportData() {
      if (this.model._localReportData) {
        if (this.model._localReportData.length > 0) {
          const res = this.model._localReportData.slice(0, 10);
          const rowEmpty = {};
          let rowFirst = res[0];
          for (const [f, v] of Object.entries(rowFirst)) {
            rowEmpty[f] = null;
          }
          res.push(rowEmpty);
          return res;
        }
      }
      return [];
    },
    reportColumnFormatters() {
      const rawFields = this.model.getRawFields();
      const columns = rawFields.Columns;
      return columns;
    }
  },
  watch: {
    "model.ats": {
      handler(newVal, oldVal) {
        if (this.model._localForceUnfreezeWorkflow) {
          this.unFreezeWorkflow();
        } else {
          this.freezeWorkflow();
        }
      },
      deep: true
    }
  },
  methods: {
    // ##################################################
    // region Back-End operations
    async beGet() {
      await this.model.get();
      this.unFreezeWorkflow();
    },
    async beSave() {
      // #####
      this.model.validate();
      if (!this.model._localValidationStatus) {
        for (let exc of this.model._localValidationResults) {
          let msg = `Error in "${exc.modelName}", field "${exc.field}": ${exc.msg}`;
          ObjAlertState.set(msg, 3);
        }
        return false;
      }
      // #####
      const _this = this;
      let res = await this.model.save();
      _this.unFreezeWorkflow();
      return this.model;
    },
    async bePreRun() {
      this.parametersExtractFromQuery();
      const model = await this.beSave();
      if (model) {
        const reportResults = await this.beReportRun();
        if (reportResults) {
          if (reportResults.length > 0) {
            ObjAlertState.set(`Report is executed successfully`, 0);
            this.columnsExtract(reportResults);
          } else {
            ObjAlertState.set(`Report is executed successfully, BUT NO RECORDS were RETURNED.`, 1);
          }
        } else {
          ObjAlertState.set(`Report is not executed`, 3);
        }
        await this.beSave();
      }
    },
    async beReportRun() {
      const rawFields = this.model.getRawFields();
      const parameters = rawFields.Parameters;
      for (const el of parameters) {
        if (this.oParValSequence.hasOwnProperty(el.DbName)) {
          el.Value = this.oParValSequence[el.DbName];
        }
      }
      const res = await this.model.run(parameters);
      return res;
    },
    async beDelete() {
      if (!await this.$root.confirmCurrentStep('Please, confirm Report deletion.')) return;
      if (this.model.ats.Id && this.model.ats.Id != 0) {
        await this.model.delete();
      }
      this.unFreezeWorkflow();
      this.$emit('onModelDeleted', this.index);
    },
    // region Back-End operations
    // ##################################################
    // region Parameters
    parametersExtractFromQuery() {
      const regexp = /(?:^|\W)@(\w+)(?!\w)/g;
      const query = this.model.ats.Query;
      const discoveredData = [...query.matchAll(regexp)];
      const arrDbNames = [];
      let Order = 0;
      for (const [idx, el] of Object.entries(discoveredData)) {
        Order++;
        const rawNewEl = {};
        const dbName = el[1];
        const name = el[1];
        arrDbNames.push(dbName);
        const i = this.model.hasParameterDbName(dbName);
        if (i !== null) {
          arrayElsSwap(this.model.ats.Parameters, idx, i);
          continue;
        }
        rawNewEl.Name = name;
        rawNewEl.DbName = dbName;
        rawNewEl.ReportId = this.model.ats.Id;
        this.parametersInsertNew(idx, rawNewEl);
      }
      this.parametersRemoveNotListed(arrDbNames);
      return this;
    },
    parametersRemoveNotListed(list) {
      this.model.ats.Parameters = this.model.ats.Parameters.filter((mParameter, i) => {
        return list.includes(mParameter.ats.DbName);
      });
      this.parametersRecalcOrder();
    },
    parametersReorder(index, offset) {
      if (offset > 0) {
        arrayElSetLater(this.model.ats.Parameters, index);
      } else {
        arrayElSetEarlier(this.model.ats.Parameters, index);
      }
      this.parametersRecalcOrder();
      return this;
    },
    parametersInsertNew(index, data = null) {
      if (index === 'last') {
        const length = this.model.ats.Parameters.length;
        index = length + 1;
      }
      const el = new mReportParameter();
      if (data) {
        el.setRawFields(data);
      }
      arrayElInsertAt(this.model.ats.Parameters, el, index);
      this.parametersRecalcOrder();
      return this;
    },
    parametersDelete(index) {
      arrayElRemoveByIndex(this.model.ats.Parameters, index);
      this.parametersRecalcOrder();
      return this;
    },
    parametersRecalcOrder() {
      for (let [key, value] of Object.entries(this.model.ats.Parameters)) {
        value.ats.Order = parseInt(key) + 1;
      }
    },
    onParameterValueChanged(dbName, value) {
      this.oParValSequence[dbName] = value;
    },
    parametersGetIndexByDbName(dbName) {
      return this.model.ats.Parameters.findIndex((mParameter) => {
        return mParameter.ats.DbName === dbName;
      });
    },
    // endregion Parameters
    // ##################################################
    // region Columns
    columnsExtract(reportResults) {
      if (!reportResults.length) {return null;}
      const firstRow = reportResults[0];
      const colNames = Object.keys(firstRow);
      const discoveredData = colNames;
      const arrDbNames = [];
      for (const [idx, el] of Object.entries(discoveredData)) {
        const rawNewEl = {};
        const dbName = el;
        arrDbNames.push(dbName);
        const i = this.model.hasColumnDbName(dbName);
        if (i !== null) {
          arrayElsSwap(this.model.ats.Columns, idx, i);
          continue;
        }
        rawNewEl.Name = dbName;
        rawNewEl.DbName = dbName;
        rawNewEl.ReportId = this.model.ats.Id;
        this.columnsInsertNew(idx, rawNewEl);
      }
      this.columnsRemoveNotListed(arrDbNames);
      return this;
    },
    columnsRemoveNotListed(list) {
      this.model.ats.Columns = this.model.ats.Columns.filter((mColumn, i) => {
        return list.includes(mColumn.ats.DbName);
      });
      this.columnsRecalcOrder();
    },
    columnsReorder(index, offset) {
      if (offset > 0) {
        arrayElSetLater(this.model.ats.Columns, index);
      } else {
        arrayElSetEarlier(this.model.ats.Columns, index);
      }
      this.columnsRecalcOrder();

      return this;
    },
    columnsInsertNew(index, data = null) {
      if (index === 'last') {
        const length = this.model.ats.Parameters.length;
        index = length + 1;
      }
      const el = new mReportColumn();
      if (data) {
        el.setRawFields(data);
      }
      arrayElInsertAt(this.model.ats.Columns, el, index);
      this.columnsRecalcOrder();
      return this;
    },
    columnsDelete(index) {
      arrayElRemoveByIndex(this.model.ats.Columns, index);
      this.columnsRecalcOrder();
      return this;
    },
    columnsRecalcOrder() {
      for (let [key, value] of Object.entries(this.model.ats.Columns)) {
        value.ats.Order = parseInt(key) + 1;
      }
    },
    // endregion Columns
    // ##################################################
    async onDiscard() {
      if (!await this.$root.confirmCurrentStep('Please, confirm discard changes.')) return;
      this.model.revert();
      await this.beGet();
      this.unFreezeWorkflow();
    },
    freezeWorkflow() {
      this.flagModelIsChanged = true;
      this.$emit('freezeWorkflow', this.index);
    },
    unFreezeWorkflow() {
      this.flagModelIsChanged = false;
      this.$emit('unFreezeWorkflow');
    }
    // ##################################################
  }
}
</script>

<style lang="scss" scoped>
#component {
  padding-bottom: 5px;
}
</style>
